module.exports = __webpack_public_path__ + "static/media/deer.901a84ad.svg";